// Top toolbar: zoom controls only
export const PdfZoomControls = ({
  displayPercent,
  onZoomIn,
  onZoomOut,
  onResetZoom,
  currentPage,
  totalPages,
  stickyTopOffset = 0,
  leftActions = null
}) => {
  return (
    <div className="pdf-controls" style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '0.75rem',
      padding: '0.5rem 1rem',
      backgroundColor: '#fff',
      flexShrink: 0,
      width: '100%',
      boxSizing: 'border-box'
    }}>
      {/* Page indicator (read-only) */}
      <span style={{
        fontSize: '0.9rem',
        color: '#555',
        whiteSpace: 'nowrap'
      }}>
        Page {currentPage} / {totalPages}
      </span>

      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        flexWrap: 'nowrap',
        marginLeft: 'auto'
      }}>
        {leftActions ? (
          <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
            {leftActions}
          </div>
        ) : null}

        {/* Zoom Controls */}
        <div className="zoom-controls" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          flexWrap: 'nowrap'
        }}>
          <button onClick={onZoomOut} className="btn-icon" style={{ padding: '0.5rem 0.85rem' }}>
            −
          </button>
          <button onClick={onResetZoom} className="btn-icon" style={{ padding: '0.5rem 0.85rem', whiteSpace: 'nowrap' }}>
            {displayPercent != null ? `${displayPercent}%` : '...'}
          </button>
          <button onClick={onZoomIn} className="btn-icon" style={{ padding: '0.5rem 0.85rem' }}>
            +
          </button>
        </div>
      </div>
    </div>
  );
};

// Bottom toolbar: page navigation
export const PdfPageControls = ({
  currentPage,
  totalPages,
  onPrevPage,
  onNextPage
}) => {
  return (
    <div className="pdf-page-controls" style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '1rem',
      padding: '0.75rem 1rem',
      backgroundColor: '#fff',
      borderTop: '1px solid #ddd',
      flexShrink: 0
    }}>
      <button
        onClick={onPrevPage}
        disabled={currentPage <= 1}
        className="btn-icon"
        style={{
          padding: '0.6rem 1.5rem',
          fontSize: '1rem',
          opacity: currentPage <= 1 ? 0.4 : 1,
          cursor: currentPage <= 1 ? 'default' : 'pointer'
        }}
      >
        Prev
      </button>
      <span style={{ minWidth: '120px', textAlign: 'center', fontWeight: 'bold', fontSize: '1rem' }}>
        Page {currentPage} of {totalPages}
      </span>
      <button
        onClick={onNextPage}
        disabled={currentPage >= totalPages}
        className="btn-icon"
        style={{
          padding: '0.6rem 1.5rem',
          fontSize: '1rem',
          opacity: currentPage >= totalPages ? 0.4 : 1,
          cursor: currentPage >= totalPages ? 'default' : 'pointer'
        }}
      >
        Next
      </button>
    </div>
  );
};

// Default export for backward compatibility
const PdfControls = PdfZoomControls;
export default PdfControls;
